/**
 * Route for `delegated-payment-processing`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { DelegatedPaymentProcessingPage } from "../features/delegated-payment-processing/DelegatedPaymentProcessingPage";

export const delegatedPaymentProcessingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/delegated-payment-processing",
	component: DelegatedPaymentProcessingPage,
});

export default delegatedPaymentProcessingRoute;
